"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserActivityLevel = void 0;
var UserActivityLevel;
(function (UserActivityLevel) {
    UserActivityLevel["Low"] = "low";
    UserActivityLevel["Medium"] = "medium";
    UserActivityLevel["High"] = "high";
})(UserActivityLevel || (exports.UserActivityLevel = UserActivityLevel = {}));
//# sourceMappingURL=user.js.map